import { settingSelectors } from 'src/app/core/settings/settings.selectors'
import { UserRole } from 'src/app/features/role/user-role/user-role'
import { configurationOptionSelectors } from 'src/app/features/configuration-option/configuration-option.selectors'
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { Store } from '@ngrx/store'
import { AppState } from '../../../../core/core.state'
import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { markFormGroupDirty } from '../../../../shared/utils/mark-form-dirty'
import {
  catchError,
  filter,
  map,
  startWith,
  switchMap,
  take,
  tap,
  timeout,
  withLatestFrom
} from 'rxjs/operators'
import { SaleItem } from '../sale-item'
import moment from 'moment-mini'
import { Moment } from 'moment-mini'
import { BehaviorSubject, combineLatest, Observable, of } from 'rxjs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { ConfigurationService } from '../../../../shared/services/configuration.service'
import { SaleItemPurchaseParamsFormComponent } from '../form-purchase-params/form.component'
import { Dictionary } from '@ngrx/entity'
import { environment } from 'src/environments/environment'
import { Actions, ofType } from '@ngrx/effects'
import { subscriptionActions } from 'src/app/features/subscription/subscription.actions'
import { subscriptionSelectors } from 'src/app/features/subscription/subscription.selectors'
import { Subscription } from 'src/app/features/subscription/subscription'
import { SubscriptionService } from 'src/app/features/subscription/subscription.service'
import { memberSelectors } from 'src/app/features/member/member.selectors'
import { Member, MemberStatus } from 'src/app/features/member/member'
import { PayMethodType } from '../../payment/payment'
import { ConfigurationOption } from 'src/app/features/configuration-option/configuration-option'
import { getPriceForCurrentMonth } from 'src/app/shared/until'
import { UserRoleHelperService } from 'src/app/shared/services/user-role-helper.service'
import { userRoleActions } from 'src/app/features/role/user-role/user-role.actions'
import { Organization } from 'src/app/features/organization/organization'
import { organizationSelectors } from 'src/app/features/organization/organization.selectors'
import { Role } from 'src/app/features/role/role'
import { roleSelectors } from 'src/app/features/role/role.selectors'
import { Site } from 'src/app/shared/site/site'
import { siteSelectors } from 'src/app/shared/site/site.selectors'
import { userRoleSelectors } from 'src/app/features/role/user-role/user-role.selectors'
import { Sale, StatusCode } from '../../sale'
import { UtilityService } from 'src/app/core/utility.service'
import { subscriberSelectors } from 'src/app/features/subscription/subscriber/subscriber.selectors'
import { subscriberActions } from 'src/app/features/subscription/subscriber/subscriber.actions'
import { Subscriber } from 'src/app/features/subscription/subscriber/subscriber'
import { subscriptionLinkedSubscriptionsActions } from 'src/app/features/subscription-linked-subscriptions/subscription-linked-subscriptions.actions'
import { SaleItemCreateFormState } from '../create-form-state.model'

@UntilDestroy()
@Component({
  selector: 'subs-sale-item-form-create',
  templateUrl: 'form.component.html',
  styleUrls: ['./form.component.scss']
})
export class SubsSaleItemFormCreateComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<Partial<SaleItem>>()
  @Output() formStateChange = new EventEmitter<SaleItemCreateFormState>()
  @Input() customerCategoryId: any
  @Input() selectedCustomerPersonId: number
  @Input() saleId: any
  @Input() loading: any = false
  @Input() typeProduct: string

  public form: UntypedFormGroup
  public subscriptionIds: number[] = []
  public maxSimultaneousHasBeenReached: boolean = false
  private selectedSubscription$ = new BehaviorSubject<Subscription | null>(null)
  public partialPrice: number
  public isLoading: boolean = true
  public isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false)
  private sameSubscriber: Subscriber = null
  public isDirectDebit$: Observable<boolean>
  public userRoles$: BehaviorSubject<UserRole[]> = new BehaviorSubject([])
  public sameSubscriptionSubscriber$: BehaviorSubject<Subscriber> =
    new BehaviorSubject(null)
  public categories$: Observable<string[]>
  public selectedLanguage$: Observable<string>
  public customerPerson$: Observable<Member>
  public subscription: Subscription
  public isAvailable: boolean = true
  public isNotAvailableText: string
  public organizationEntities$: Observable<Dictionary<Organization>>
  public chooseCategoryAllowed$: Observable<boolean>
  public configOption$: Observable<ConfigurationOption>
  public configOption: ConfigurationOption
  public allSubscriptions$: Observable<Subscription[]>
  public startDateErrorString: string = null
  public roleEntities$: Observable<Dictionary<Role>>
  public siteEntities$: Observable<Dictionary<Site>>
  public userRolesEntities$: Observable<Dictionary<UserRole>>
  public orgCategoryByUserRole: number
  constructor(
    private fb: UntypedFormBuilder,
    private utilityService: UtilityService,
    public userRoleHelperService: UserRoleHelperService,
    public subscriptionService: SubscriptionService,
    private actions$: Actions,
    private store: Store<AppState>,

    public config: ConfigurationService
  ) {}

  ngOnInit() {
    if (this.selectedCustomerPersonId) {
      this.store.dispatch(
        subscriberActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              memberId: this.selectedCustomerPersonId,

              endDate: {
                [CondOperator.GREATER_THAN_EQUALS]: moment().toISOString()
              },

              status: {
                [CondOperator.NOT_IN]: [
                  MemberStatus.INACTIVE,
                  MemberStatus.INACTIVE_NO_PAYMENT
                ]
              }
            },
            join: { field: 'subscription' }
          })
        })
      )
    }
    this.roleEntities$ = this.store.select(roleSelectors.selectEntities)
    this.userRolesEntities$ = this.store.select(
      userRoleSelectors.selectEntities
    )
    this.organizationEntities$ = this.store.select(
      organizationSelectors.selectEntities
    )
    this.siteEntities$ = this.store.select(siteSelectors.selectEntities)
    this.isLoading = false
    this.isLoading$.next(true)
    if (this.selectedCustomerPersonId) {
      this.store.dispatch(
        userRoleActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: { userId: this.selectedCustomerPersonId },
            join: [{ field: 'role' }, { field: 'organization' }]
          })
        })
      )
    }
    this.configOption$ = this.store.select(
      configurationOptionSelectors.selectByKey,
      `pay_only_first_term_on_def_end_date`
    )
    this.configOption$.pipe(untilDestroyed(this)).subscribe((configOp) => {
      this.configOption = configOp
    })
    this.selectedLanguage$ = this.store.select(
      settingSelectors.selectById,
      'language'
    )
    this.customerPerson$ = this.store.select(
      memberSelectors.selectById,
      this.selectedCustomerPersonId
    )

    this.categories$ = this.selectedLanguage$.pipe(
      withLatestFrom(this.customerPerson$),
      switchMap(([language, customerPerson]) => {
        return this.store.select(configurationOptionSelectors.selectAll).pipe(
          map((categories) => {
            let categoriesOptions = []
            for (let category = 0; category < 10; category++) {
              const categoryDescription = categories.find(
                (cat) =>
                  cat.key === `${language}_category${category}desc` &&
                  (cat.siteId === customerPerson?.siteId || !cat.siteId) &&
                  cat.value?.length
              )
              categoryDescription
                ? categoriesOptions.push(categoryDescription)
                : null
            }
            let mappedCategeries = JSON.parse(JSON.stringify(categoriesOptions))
            mappedCategeries.map((item) => {
              if (Number(item.siteId) != 0 && !item.siteId) {
                item.siteId = customerPerson.siteId
              }
            })
            categoriesOptions = JSON.parse(JSON.stringify(mappedCategeries))
            return categoriesOptions
          }),
          map((configOptions) => {
            let nCategories = environment.moduleConfigs.hasExtendedCategories
              ? 9
              : 4
            return configOptions
              .filter(
                (c, i) =>
                  (c.siteId == customerPerson?.siteId && i <= nCategories) ||
                  (!c.siteId && i <= nCategories)
              )
              .map((option) => option.key)
              .map((key) => key.split(language + '_').pop())
          })
        )
      })
    )
    this.store.dispatch(
      subscriptionActions.fetchMany({
        params: RequestQueryBuilder.create({
          limit: 100,
          search: {
            isActive: true
          },
          join: [
            { field: 'tags' },
            { field: 'translations' },
            { field: 'prerequisiteSubscriptions' },
            { field: 'prerequisiteSubscriptions.translations' },
            { field: 'documents' },
            { field: 'linkedSubscriptions' },
            { field: 'linkedSubscriptions.linkedSubscription' },
            { field: 'linkedSubscriptions.linkedSubscription.translations' }
          ]
        })
      })
    )
    this.form = this.fb.group({
      quantity: [1, []],
      customerCategory: [null, []],
      subscriptionId: [null, [Validators.required]],
      userRoleId: [null, []],
      defaultStartDate: [null, []],
      defaultEndDate: [null, []],
      generalTerms: [null, []]
    })

    this.form.statusChanges
      .pipe(startWith(this.form.status), untilDestroyed(this))
      .subscribe(() => this.emitFormState())

    this.sameSubscriptionSubscriber$
      .pipe(untilDestroyed(this))
      .subscribe(() => this.emitFormState())

    this.customerPerson$.pipe(untilDestroyed(this)).subscribe((member) => {
      this.userRoleHelperService
        .getUserRolesByMember$([], member, false, false, false, true)
        .pipe(take(1))
        .subscribe((userRoles) => {
          if (userRoles.length > 0) {
            this.form.controls.userRoleId.setValidators([Validators.required])
            this.form.controls.userRoleId.setValue(userRoles[0].id)
          } else {
            this.form.controls.userRoleId.clearValidators()
            this.form.controls.userRoleId.setValue(null)
          }
          this.form.controls.userRoleId.updateValueAndValidity()
          this.userRoles$.next(userRoles)
        })
      if (member) {
      }
    })
    // observables
    this.allSubscriptions$ = this.store
      .select(subscriptionSelectors.selectAll)
      .pipe(
        map((subs) => {
          return subs.filter((s) => s.isActive == true)
        })
      )

    this.form
      .get('subscriptionId')
      .valueChanges.pipe(
        filter((productId) => !!productId),
        switchMap((subsId) =>
          this.store.select(subscriptionSelectors.selectById, subsId)
        )
      )
      .subscribe((subs) => {
        this.selectedSubscription$.next(subs)
      })

    this.isDirectDebit$ = this.selectedSubscription$.pipe(
      map((subscription) => {
        return subscription?.payMethod === PayMethodType.PAY_METHOD_DIRECT_DEBIT
      })
    )
    combineLatest([
      this.form.controls.defaultStartDate.valueChanges.pipe(
        startWith(this.form.controls.defaultStartDate.value)
      ),
      this.selectedSubscription$.asObservable(),
      this.form.controls.userRoleId.valueChanges.pipe(
        startWith(this.form.controls.userRoleId.value)
      )
    ])
      .pipe(
        untilDestroyed(this),
        withLatestFrom(
          this.customerPerson$,
          this.organizationEntities$,
          this.userRolesEntities$
        )
      )
      .subscribe(
        ([
          [startDate, subscription, selectedUserRoleId],
          member,
          orgEntities,
          userRolesEntities
        ]) => {
          if (selectedUserRoleId && userRolesEntities[selectedUserRoleId]) {
            this.orgCategoryByUserRole = userRolesEntities[selectedUserRoleId]
              .organizationId
              ? orgEntities[
                  userRolesEntities[selectedUserRoleId].organizationId
                ]?.category
              : null
          }
          if (
            subscription?.defaultEndDate &&
            moment(startDate).isAfter(moment(subscription?.defaultEndDate))
          ) {
            this.startDateErrorString =
              'subscriptionModule.startDateCannotBeEarlierThanEndDate'
          } else {
            this.startDateErrorString = null
            this.setPartialPrice(member, startDate)
          }
        }
      )
  }
  public setPartialPrice(member: Member, startDate?: string) {
    if (!this.subscription || !member) {
      return
    }

    this.partialPrice = getPriceForCurrentMonth(
      this.getPrice(this.subscription, member, false, this.configOption),
      startDate
    )
  }
  public getLinkedSubscriptionSubsIds(subscription: Subscription) {
    if (!subscription) {
      return []
    }
    let arraySubsIds = []
    if (Array.isArray(subscription.linkedSubscriptions)) {
      if (
        subscription.linkedSubscriptions.every(
          (item) => typeof item === 'number'
        )
      ) {
        arraySubsIds = subscription.linkedSubscriptions
      } else if (
        subscription.linkedSubscriptions.every(
          (item) => typeof item === 'object' && item !== null
        )
      ) {
        arraySubsIds = subscription.linkedSubscriptions.map(
          (it) => it.linkedSubscriptionId
        )
      } else {
        arraySubsIds = []
      }
    } else {
      arraySubsIds = []
    }
    if (arraySubsIds.length > 0) {
      this.actions$
        .pipe(
          ofType(subscriptionActions.upsertMany),
          take(1),
          timeout(1000),
          catchError((error) => of(null))
        )
        .subscribe((action) => {
          this.subscriptionIds = arraySubsIds
        })
      this.store.dispatch(
        subscriptionActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              id: {
                [CondOperator.IN]: arraySubsIds
              }
            },
            join: [
              { field: 'tags' },
              { field: 'translations' },
              { field: 'prerequisiteSubscriptions' },
              { field: 'prerequisiteSubscriptions.translations' },
              { field: 'documents' },
              { field: 'linkedSubscriptions' },
              { field: 'linkedSubscriptions.linkedSubscription' },
              { field: 'linkedSubscriptions.linkedSubscription.translations' }
            ]
          })
        })
      )
    } else {
      this.subscriptionIds = arraySubsIds
    }
  }
  public subsIsPayOnlyFirstTermOnDefEnDate$(subscription) {
    return combineLatest([
      this.store.select(
        configurationOptionSelectors.selectByKey,
        `pay_only_first_term_on_def_end_date`
      )
    ]).pipe(
      map(([configOption]) => {
        let isPayOnlyFirstTermOnDefEnDate = false
        if (
          configOption &&
          configOption.value == 'true' &&
          subscription &&
          subscription.defaultEndDate
        ) {
          isPayOnlyFirstTermOnDefEnDate = true
        }
        return isPayOnlyFirstTermOnDefEnDate
      })
    )
  }
  public getPrice(
    subscription: Subscription,
    member: Member,
    showTillDate: boolean = false,
    configOption
  ): number {
    if (!showTillDate) {
      return this.subscriptionService.getPriceForMember(
        subscription,
        member,
        this.orgCategoryByUserRole,
        false,
        configOption,
        {
          startDate: moment(
            this.subscriptionService.getStartDate(
              moment(this.form.controls.defaultStartDate.value)
            )
          ),
          totalPricePerPeriod: true
        }
      )
    } else {
      return this.subscriptionService.getTotalPriceForMember(
        subscription,
        member,
        this.orgCategoryByUserRole,
        showTillDate,
        {
          startDate: moment(
            this.subscriptionService.getStartDate(
              moment(this.form.controls.defaultStartDate.value)
            )
          )
        }
      )
    }
  }
  public onFormSubmit() {
    this.isLoading = true
    this.emitFormState()

    if (!this.form.valid) {
      this.form.markAsDirty()
      //this.form.setErrors(null)

      this.isLoading = false
      this.emitFormState()

      return
    }
    this.store
      .select(configurationOptionSelectors.selectByKey, `sales_person`)
      .pipe(
        take(1),
        withLatestFrom(this.organizationEntities$, this.userRoles$)
      )
      .subscribe(
        ([salesPersonIdConfigOption, organizationEntities, userRoles]) => {
          let sale: Partial<Sale>
          const selectedUserRole = this.form.controls.userRoleId.value
            ? userRoles.find(
                (it) => it.id == this.form.controls.userRoleId.value
              )
            : null
          sale = {
            siteId:
              selectedUserRole?.siteId !== null
                ? selectedUserRole?.siteId
                : environment.defaultSiteId,
            salesPersonId:
              parseInt(salesPersonIdConfigOption?.value) ??
              this.selectedCustomerPersonId,
            customerPersonId: this.selectedCustomerPersonId,
            organizationId: selectedUserRole?.organizationId,
            posId: this.utilityService.getPosId(),
            statusCode: StatusCode.INFLIGHT,
            tableGroupId: 9999999,
            saleItems: [
              {
                productId: null,
                subscriptionId: this.form.controls.subscriptionId.value,
                courseId: null,
                quantity: this.form.controls.quantity.value,
                params: {
                  defaultStartDate: this.form.controls.defaultStartDate.value,
                  generalTerms: this.form.controls.generalTerms.value
                },
                bookingId: null,
                customerCategory: this.form.controls.customerCategory.value,
                siteId:
                  selectedUserRole?.siteId !== null
                    ? selectedUserRole?.siteId
                    : environment.defaultSiteId
              }
            ]
          }
          this.isLoading = false
          this.emitFormState()

          this.onSubmit.emit(sale)
        }
      )
  }

  public onSearchSubscriptions(term: string) {
    this.store.dispatch(
      subscriptionActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            description: { [CondOperator.CONTAINS_LOW]: term }
          },
          join: [
            { field: 'tags' },
            { field: 'translations' },
            { field: 'prerequisiteSubscriptions' },
            { field: 'prerequisiteSubscriptions.translations' },
            { field: 'documents' },
            { field: 'linkedSubscriptions' },
            { field: 'linkedSubscriptions.linkedSubscription' },
            { field: 'linkedSubscriptions.linkedSubscription.translations' }
          ]
        })
      })
    )
  }
  public setSameSubEndDateAsStartDate() {
    this.sameSubscriptionSubscriber$
      .pipe(take(1))
      .subscribe((subscriber) =>
        this.form.controls.defaultStartDate.setValue(
          moment(subscriber.endDate).add(1, 'day').format('YYYY-MM-DD')
        )
      )
  }
  private fetchSelectedSubs(subscription) {
    this.store.dispatch(
      subscriptionActions.fetchMany({
        params: RequestQueryBuilder.create({
          search: {
            id: subscription.id
          },
          join: [
            { field: 'tags' },
            { field: 'translations' },
            { field: 'prerequisiteSubscriptions' },
            { field: 'prerequisiteSubscriptions.translations' },
            { field: 'documents' },
            { field: 'linkedSubscriptions' },
            { field: 'linkedSubscriptions.linkedSubscription' },
            { field: 'linkedSubscriptions.linkedSubscription.translations' }
          ]
        })
      })
    )
    this.actions$
      .pipe(
        ofType(subscriptionActions.upsertMany),
        withLatestFrom(
          this.customerPerson$,
          this.store.select(subscriberSelectors.selectAll)
        ),
        take(1),
        timeout(1000),
        catchError((error) => of(null))
      )
      .subscribe(([action, member, subscribers]) => {
        const sameSubscriptionSubscriber = this.checkSubscriber(
          subscription,
          member,
          subscribers
        )

        if (sameSubscriptionSubscriber) {
          this.sameSubscriptionSubscriber$.next(sameSubscriptionSubscriber)
        }
        this.subscription = action?.entities?.length
          ? action?.entities.find((it) => it.id == subscription.id)
          : subscription

        if (this.subscription?.termsUrl) {
          this.form.controls.generalTerms.setValidators([
            Validators.requiredTrue
          ])
          this.form.controls.generalTerms.updateValueAndValidity()
        } else {
          this.form.controls.generalTerms.setValidators([])
          this.form.controls.generalTerms.updateValueAndValidity()
        }
        this.isAvailable = true
        this.isNotAvailableText = null
        if (moment(this.subscription?.availableTillDate).isBefore(moment())) {
          this.isAvailable = false
          this.isNotAvailableText =
            'subscriptionModule.subscriptionNotAvailableAnymore'
        }
        if (this.subscription?.defaultStartDate) {
          this.form.controls.defaultStartDate.setValidators([])
          this.form.controls.defaultStartDate.setValue(
            moment(subscription.defaultStartDate).format('YYYY-MM-DD')
          )
        } else {
          this.form.controls.defaultStartDate.setValue(
            moment().format('YYYY-MM-DD')
          )
        }

        this.form.patchValue({
          subscriptionId: this.subscription?.id ?? subscription.id,
          defaultEndDate: subscription.defaultEndDate
            ? moment().format('YYYY-MM-DD')
            : null
        })
        this.getLinkedSubscriptionSubsIds(this.subscription)
        this.emitFormState()
      })
  }

  public subscriptionSelected(subscription: Subscription) {
    this.subscription = null
    this.sameSubscriptionSubscriber$.next(null)
    if (subscription) {
      this.store.dispatch(
        subscriptionLinkedSubscriptionsActions.fetchMany({
          params: RequestQueryBuilder.create({
            search: {
              subscriptionId: subscription.id
            }
          })
        })
      )
    }
    this.fetchSelectedSubs(subscription)
    this.emitFormState()
  }

  public submitFromParent() {
    this.onFormSubmit()
  }

  private emitFormState() {
    this.formStateChange.emit({
      canSubmit: !(
        this.form?.invalid ||
        this.isLoading ||
        this.maxSimultaneousHasBeenReached ||
        !this.isAvailable ||
        (this.sameSubscriptionSubscriber$.value &&
          !this.sameSubscriptionSubscriber$.value?.endDate)
      ),
      isLoading: this.isLoading,
      submitLabelKey: 'general.save'
    })
  }
  private checkSubscriber(
    subscription: Subscription,
    member: Member,
    subscribers: Subscriber[]
  ) {
    const activeCurrentSubscribers = subscribers
      ?.filter((s) => s.memberId == member?.id)
      ?.filter((s) => {
        let subStatus = s.status

        if (subStatus == MemberStatus.GLOBAL && member) {
          subStatus = member.status
        }

        if (
          subStatus == MemberStatus.INACTIVE ||
          subStatus == MemberStatus.INACTIVE_NO_PAYMENT ||
          moment(s.endDate).isBefore(moment(s.startDate))
        ) {
          return false
        }

        return (
          s.subscriptionId === subscription.id &&
          moment().startOf('day').isBefore(moment(s.endDate))
        )
      })
    if (
      subscription.maxSimultaneous > 0 &&
      activeCurrentSubscribers.length >= subscription.maxSimultaneous
    ) {
      this.maxSimultaneousHasBeenReached = true
      return null
    }
    this.sameSubscriber = activeCurrentSubscribers
      ?.sort(
        (a, b) => moment(b.endDate).valueOf() - moment(a.endDate).valueOf()
      )
      .find(
        (s) =>
          s.subscriptionId === subscription.id &&
          moment().startOf('day').isBefore(moment(s.endDate))
      )
    return this.sameSubscriber
  }
  disabledStartDate = (currentDate: Date): boolean => {
    return moment(currentDate).isBefore(moment().startOf('day'))
  }
  public getCategoryValue(categoryDescription: string): number {
    const regex = /\d+/

    return Number(categoryDescription.match(regex)?.[0])
  }
}
